<template>
  <div class="relative text-app-color group">
    <div v-if="isCreator" class="absolute top-3 right-10 opacity-0 group-hover:opacity-100" :class="{'opacity-100': isModalOpen}">
      <DropdownModule
        ref="menu"
        icon="icon-more-horizontal text-25 text-app-color right-0"
        class="select-none z-10 p-5"
        :width="74"
        remove-optional-top-gap
        append-to-body
        button-opacity="90"
        background="bg-primary"
        @click="isModalOpen = true"
        @close="isModalOpen = false"
      >
        <ButtonModule
          :prefix="`icon-edit text-17 ${isDraculaTheme ? 'text-main-color' : ''}`"
          class="py-13 px-10 relative"
          :class="isDarkMode ? 'text-app-color' : 'text-grey-main'"
          has-hover
          tooltip-text="edit"
          tooltip-size="11"
          button-opacity="80"
          @click="setEdit"
        />

        <ButtonModule
          :prefix="`icon-delete text-17 ${isDraculaTheme ? 'text-main-color' : ''}`"
          class="py-13 px-10 relative"
          :class="isDarkMode ? 'text-app-color' : 'text-grey-main'"
          has-hover
          tooltip-text="delete"
          tooltip-size="11"
          button-opacity="80"
          @click="deleteTemplate"
        />
      </DropdownModule>
    </div>

    <div class="rounded-10 border-2 border-grey-550 p-10 px-30 cursor-pointer" @click="setTemplate">
      <img :src="template.templateAttachments[0].url" alt="template">
    </div>

    <p v-if="!isEdit" class="text-16 text-center mt-10">{{ title }}</p>

    <input
      v-else
      ref="inputRef"
      v-model="title"
      type="text"
      class="w-full text-16 bg-transparent outline-none mt-10 text-center"
      @blur="unsetEdit"
    >

    <SelectModule v-if="isCreator && isTeamAccount" v-model="select" class="w-150 mx-auto text-14 rounded-4 mt-10" :options="options" />
  </div>
</template>

<script>
import { computed, defineComponent, nextTick, ref } from 'vue'
import { useStore } from 'vuex'

import DropdownModule from '@/components/shared/form-controls/DropdownModule'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import SelectModule from '@/components/shared/form-controls/SelectModule'

export default defineComponent({
  components: { DropdownModule, ButtonModule, SelectModule },

  props: {
    template: Object,
    type: String
  },

  emits: ['setTemplate', 'dragStart', 'dragStop'],

  setup (props, { emit }) {
    const { state, commit, dispatch, getters } = useStore()
    let timer = null

    const isModalOpen = ref(false)
    const isEdit = ref('')
    const inputRef = ref(null)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isDraculaTheme = computed(() => getters.isDraculaTheme)
    const isTeamAccount = computed(() => getters.isTeamAccount)
    const user = computed(() => state.profile.user)

    const isCreator = computed(() => props.template.userId === user.value.id)

    const select = computed({
      get: () => {
        return { name: props.template.teamId ? 'For everyone' : 'For me only' }
      },
      set: (value) => {
        if (value.name !== select.value.name) {
          if (props.type !== 'all') commit('deleteTemplate', props.template.id)

          dispatch('updateTemplate', {
            id: props.template.id,
            title: title.value,
            isShared: value.name === 'For everyone'
          })
        }
      }
    })

    const options = [{ name: 'For everyone' }, { name: 'For me only' }]

    const title = computed({
      get: () => {
        return props.template.title
      },
      set: (value) => {
        clearTimeout(timer)

        if (value.trim() !== '') {
          timer = setTimeout(() => {
            dispatch('updateTemplate', {
              id: props.template.id,
              title: value,
              isShared: !!props.template.teamId
            })
          }, 300)
        }
      }
    })

    function deleteTemplate () {
      commit('loading', true)
      dispatch('deleteTemplate', props.template.id)
    }

    function setTemplate () {
      emit('setTemplate', props.template.id)
    }

    function setEdit () {
      emit('dragStop')
      isEdit.value = true

      nextTick(() => {
        inputRef.value.focus()
        inputRef.value.setSelectionRange(0, 9999)
      })
    }

    function unsetEdit () {
      emit('dragStart')
      isEdit.value = false
    }

    return {
      isModalOpen,
      title,
      isEdit,
      isDarkMode,
      isDraculaTheme,
      isTeamAccount,
      select,
      options,
      isCreator,
      // ref
      inputRef,
      // function
      setEdit,
      unsetEdit,
      setTemplate,
      deleteTemplate
    }
  }
})
</script>
